// extracted by mini-css-extract-plugin
export var redoItem = "_p1-1";
export var redoTrigger = "_p1-0";